import React from 'react';
import styled from 'styled-components';
import {
  FILTER_AND_SORT_FAB_X_OFFSET_CSS_VARIABLE,
  FILTER_AND_SORT_FAB_Y_OFFSET_CSS_VARIABLE,
} from './useFilterAndSortFABOffset';

export const FilterAndSortWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <Wrapper tabIndex={-1}>{children}</Wrapper>;
};

const Wrapper = styled.div`
  position: fixed;
  bottom: var(${FILTER_AND_SORT_FAB_Y_OFFSET_CSS_VARIABLE}, 0px);
  right: var(${FILTER_AND_SORT_FAB_X_OFFSET_CSS_VARIABLE}, 0px);
  width: fit-content;
  z-index: 1;
`;
